import { observer } from "mobx-react-lite";
import MainLayout, { MAIN_RIGHT_TOP_HEIGHT } from "../MainLayout";
import { useNavigate } from "react-router-dom";
import { HorizontalLayout, VerticalLayout } from "../../common/common-layout";
import { TitleLargeMedium, TitleNormal } from "../../common/common-text";
import BTBox from "../../common/components/BTBox";
import BTInputBox from "../../common/components/BTInputBox";
import BTButton from "../../common/components/BTButton";
import theme from '../../common/theme';
import { dialogStore } from '../../store/DialogStore';
import { useEffect, useState } from "react";
import { fetchCopyright, updateCopyright } from "../../common/firebase/Firestore";

const HomePageInfo = () => {
    return (
        <MainLayout>
            <HomePageInfoBody />
        </MainLayout>
    );
};

export default HomePageInfo;

const HomePageInfoBody = observer(() => {
    const navigate = useNavigate();

    useEffect(() => {
        async function loadData() {
            const copyright = await fetchCopyright();
            setCopyrightInfo(copyright);
        }

        loadData();
    }, []);

    const [copyrightInfo, setCopyrightInfo] = useState({
        companyName: '',
        address: '',
        corpRegNo: '',
        representPersonName: '',
        copyright: '',
    });

    const handleSave = async (): Promise<void> => {
        dialogStore.showDialog({
            title: '알림',
            message: '정말 저장하시겠습니까?',
            onConfirm: async () => {
                try {
                    await updateCopyright(copyrightInfo);
                    dialogStore.showDialog({
                        title: '성공',
                        message: '저장되었습니다.',
                        onConfirm: () => {},
                    });
                } catch (error) {
                    dialogStore.showDialog({
                        title: '에러',
                        message: '저장 중 오류가 발생했습니다.',
                        onConfirm: () => {},
                    });
                    console.error(error);
                }
            },
            onCancel: () => {
                handleCancel();
            },
            onClose: () => {
                console.log('닫기');
            },
        });
    };

    const handleCancel = (): void => {
        navigate(-1);
    };

    return (
        <div style={{ width: '100%', minHeight: `calc(100vh - ${MAIN_RIGHT_TOP_HEIGHT})`, display: 'flex', flexDirection: 'column' }} >
            <VerticalLayout height={'auto'} paddingLeft={36} paddingRight={36}>
                <form style={{ width: 516 }}>
                <TitleLargeMedium>홈페이지 정보 관리</TitleLargeMedium>
                <BTBox height='24px' />
                    <div style={{ width: '678px' }}>
                        <TitleNormal color='#8a92a6'>회사명</TitleNormal>
                        <BTBox height='8px' />
                        <HorizontalLayout>
                            <BTInputBox
                                value={copyrightInfo.companyName}
                                onChange={(e) =>
                                    setCopyrightInfo({ ...copyrightInfo, companyName: e.target.value })
                                }
                            />
                        </HorizontalLayout>
                        <BTBox height='16px' />
                        <TitleNormal color='#8a92a6'>주소</TitleNormal>
                        <BTBox height='8px' />
                        <HorizontalLayout>
                            <BTInputBox
                                value={copyrightInfo.address}
                                onChange={(e) =>
                                    setCopyrightInfo({ ...copyrightInfo, address: e.target.value })
                                }
                            />
                        </HorizontalLayout>
                        <BTBox height='16px' />
                        <TitleNormal color='#8a92a6'>사업자등록번호</TitleNormal>
                        <BTBox height='8px' />
                        <HorizontalLayout>
                            <BTInputBox
                                value={copyrightInfo.corpRegNo}
                                onChange={(e) =>
                                    setCopyrightInfo({ ...copyrightInfo, corpRegNo: e.target.value })
                                }
                            />
                        </HorizontalLayout>
                        <BTBox height='16px' />
                        <TitleNormal color='#8a92a6'>대표자명</TitleNormal>
                        <BTBox height='8px' />
                        <HorizontalLayout>
                            <BTInputBox
                                value={copyrightInfo.representPersonName}
                                onChange={(e) =>
                                    setCopyrightInfo({ ...copyrightInfo, representPersonName: e.target.value })
                                }
                            />
                        </HorizontalLayout>
                        <BTBox height='16px' />
                        <TitleNormal color='#8a92a6'>Copyright</TitleNormal>
                        <BTBox height='8px' />
                        <HorizontalLayout>
                            <BTInputBox
                                value={copyrightInfo.copyright}
                                onChange={(e) =>
                                    setCopyrightInfo({ ...copyrightInfo, copyright: e.target.value })
                                }
                            />
                        </HorizontalLayout>
                    </div>
                </form>
            </VerticalLayout>
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', paddingRight: '76px', paddingBottom: '76px' }}>
                <HorizontalLayout style={{ marginTop: 'auto', justifyContent: 'flex-end' }}>
                    <BTButton color={theme.colors.bbTech} textColor='white' onClick={handleSave}>저장</BTButton>
                    <BTBox width='24px' />
                    <BTButton onClick={handleCancel}>취소</BTButton>
                </HorizontalLayout>
            </div>
        </div>
    );
});
